export interface CreateApplication {
    applicationArchitecture: string,
    applicationCloudCompute: string,
    applicationCloudProvider: string,
    applicationDatabase: string,
    applicationDescription: string,
    applicationFramework: string,
    applicationLanguage: string,
    applicationName: string,
    applicationProjectId: number,
    applicationUserId: number,
    applicationWorkspaceId: number
}
export const CreateApplicationInit: CreateApplication = {
    applicationArchitecture: "",
    applicationCloudCompute: "",
    applicationCloudProvider: "",
    applicationDatabase: "",
    applicationDescription: "",
    applicationFramework: "",
    applicationLanguage: "",
    applicationName: "",
    applicationProjectId: 0,
    applicationUserId: 0,
    applicationWorkspaceId: 0,
}

